import { validateInputs } from "../utils/form";

export default function () {
  const dialogSuccess = document.getElementById('modalSuccessMessage');
  const dialogError = document.getElementById('modalErrorMessage');
  const form = document.querySelector('#contact-form');

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const isValid = validateInputs(form);

      if(isValid) {
        const formData = new FormData(form);
        let result;

        try {
          const response = await fetch('', {
            method: "POST",
            body: formData,
          });
          result = await response.json();
        } catch (error) {
          dialogError.showModal();
        }

        // success
        if (result?.success) {
          dialogSuccess.showModal();
          form.reset();
          return;
        }

        // error
        dialogError.showModal();
      }
    });
  }
}
